import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  // Chip,
  Paper,
  Divider,
  TextField,
  InputAdornment,
} from '@mui/material';
import {
  Person as PersonIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import PropTypes from 'prop-types';
import { GoPerson } from 'react-icons/go';

const AvailableStudents = ({
  students,
  selectedStudent,
  onStudentSelect,
  searchTerm,
  setSearchTerm,
}) => {
  return (
    <Card>
      <CardContent>
        <Box className='flex items-center gap-2 mb-4'>
          <Box className='size-8 bg-blue-500 rounded-lg flex items-center justify-center'>
            <Typography className='text-white font-bold text-sm'>
              <GoPerson className='size-5' />
            </Typography>
          </Box>
          <Typography variant='h6' className='text-blue-700 font-semibold'>
            Available Students
          </Typography>
        </Box>

        {/* Search Box */}
        <Box className='mb-4'>
          <TextField
            fullWidth
            size='small'
            placeholder='Search by name, student ID'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIcon className='text-gray-400' fontSize='small' />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                backgroundColor: '#f8fafc',
                '&:hover': {
                  backgroundColor: '#f1f5f9',
                },
                '&.Mui-focused': {
                  backgroundColor: 'white',
                },
              },
            }}
          />
          <Typography variant='body2' className='text-gray-500 ml-2'>
            Click to select a student
          </Typography>
        </Box>

        <Box className='max-h-96 overflow-y-auto space-y-2'>
          {students?.map((student) => (
            <Paper
              key={student.id}
              className={`p-3 cursor-pointer transition-all ${
                selectedStudent?.id === student.id
                  ? 'bg-blue-50 border-2 border-blue-200'
                  : 'hover:bg-gray-50 border border-gray-200'
              }`}
              onClick={() => onStudentSelect(student)}
            >
              <Box className='flex items-center gap-3'>
                <Avatar className='size-8 bg-blue-500'>
                  <PersonIcon fontSize='small' />
                </Avatar>
                <Box className='flex-1'>
                  <Typography variant='subtitle2' className='font-medium'>
                    {student?.studentName}
                  </Typography>
                  <Typography variant='body2' className='text-gray-500'>
                    {student?.studentId}
                  </Typography>
                  {/* <Chip
                    label={`Class ${student?.class}`}
                    size='small'
                    variant='outlined'
                    className='mt-1'
                  /> */}
                </Box>
                {student?.status ? (
                  <Box className='size-3 bg-green-500 rounded-full'></Box>
                ) : (
                  <Box className='size-3 bg-red-500 rounded-full'></Box>
                )}
              </Box>
            </Paper>
          ))}

          {/* No results message */}
          {students.length === 0 && searchTerm && (
            <Box className='text-center py-8'>
              <Typography variant='body2' className='text-gray-500'>
                No students found matching "{searchTerm}"
              </Typography>
            </Box>
          )}
        </Box>

        <Divider className='my-4' />
        <Typography variant='body2' className='text-gray-500 text-center'>
          📊 {students.length} of {students.length} students
          {searchTerm && ` (filtered)`}
        </Typography>
      </CardContent>
    </Card>
  );
};

AvailableStudents.propTypes = {
  students: PropTypes.array.isRequired,
  selectedStudent: PropTypes.object,
  onStudentSelect: PropTypes.func.isRequired,
};

export default AvailableStudents;
